import React from "react";
import {
  defineBlock,
  smartProps,
  EditableDiv,
  useSmartProp,
  useInspectorControl,
} from "@smartfire/gutenberg-react";
import EditableText from "../shared/editable-text";
import style from "./block.module.scss";
import { PanelBody, PanelRow, SelectControl } from "@wordpress/components";

function Inspector() {
  const [theme, setTheme] = useSmartProp("theme");

  return (
    <>
      <PanelBody title="Configuration affichage" initialOpen={true}>
        <PanelRow>
          <SelectControl
            label="Thème"
            options={[
              { label: "Thème blanc", value: "white" },
              { label: "Thème transparent", value: "transparent" },
            ]}
            value={theme}
            onChange={(value) => setTheme(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ theme }) {
  useInspectorControl(Inspector);

  return (
    <div
      className={
        theme === "transparent" ? style.blockTransparent : style.blockWhite
      }
    >
      <div className={style.content}>
        <EditableText
          className={style.title}
          tagName="h2"
          smartProp="title"
          placeholder={"Entrez un titre"}
        />
        <div className={style.tiret} />
        <EditableDiv
          className={style.text}
          smartProp="text"
          placeholder={"Entrez un texte"}
          allowedFormats={["core/bold", "core/link", "advanced/color"]}
        />
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault(""),
    text: smartProps.string.withDefault(""),
    theme: smartProps.string.withDefault("white"),
  },
  setup: {
    title: "Contenu simple",
  },
});
